"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BarChart = void 0;

var _maxBy2 = _interopRequireDefault(require("lodash/maxBy"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

var _ChartTooltip = require("../DataVis/ChartTooltip");

var _MousePositionContext = require("../DataVis/MousePositionContext");

var _useHasEnteredViewPort = require("../DataVis/utils/useHasEnteredViewPort");

var _Flex = require("../Flex");

var _Typography = require("../Typography");

var _Bar = require("./Bar");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ChartContainer = (0, _styledComponents.default)(_Flex.Flex).withConfig({
  displayName: "BarChart__ChartContainer",
  componentId: "sc-1bkepsb-0"
})(["border-bottom:1px solid ", ";"], (0, _helpers.color)("black10"));

function useHighlightLabelPositionConstraints(wrapperDiv, labelDiv) {
  // Constrain highlight label to be within the bounds of the graph
  (0, _react.useEffect)(function () {
    if (!wrapperDiv || !labelDiv) {
      return;
    } // reset highlight label position


    labelDiv.style.left = null;
    labelDiv.style.right = null; // force layout to find centered position

    labelDiv.offsetWidth;
    var wrapperRect = wrapperDiv.getBoundingClientRect();
    var labelRect = labelDiv.getBoundingClientRect(); // check for overlap with BarChart left bound

    var labelLeftOffset = wrapperRect.left - labelRect.left;

    if (labelLeftOffset > 0) {
      // label is too far to the left, compensate
      labelDiv.style.left = labelLeftOffset + "px";
      return;
    } // check for overlap with BarChart right bound


    var labelRightOffset = labelRect.right - wrapperRect.right;

    if (labelRightOffset > 0) {
      // label is too far to the right, compensate
      labelDiv.style.right = labelRightOffset + "px";
    }
  });
}

/**
 * BarChart is a component which displays some bars of varying heights in a row.
 * Useful for histograms etc.
 * @param props props
 */
var BarChart = function BarChart(_ref) {
  var bars = _ref.bars,
      minLabel = _ref.minLabel,
      maxLabel = _ref.maxLabel;
  var wrapperRef = (0, _react.useRef)(null);
  var highlightLabelRef = (0, _react.useRef)(null);
  useHighlightLabelPositionConstraints(wrapperRef.current, highlightLabelRef.current);
  var hasEnteredViewport = (0, _useHasEnteredViewPort.useHasEnteredViewport)(wrapperRef);

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      minHeight = _useState2[0],
      setMinHeight = _useState2[1];

  var maxValue = (0, _maxBy2.default)(bars, function (item) {
    return item.value;
  }).value;
  var allZero = bars.every(function (item) {
    return item.value === 0;
  });
  return _react.default.createElement(_MousePositionContext.ProvideMousePosition, null, _react.default.createElement(_Flex.Flex, {
    flexDirection: "column",
    ref: wrapperRef,
    flexGrow: "1",
    id: "flex-wrapper"
  }, _react.default.createElement(ChartContainer, {
    height: "80px",
    alignItems: "flex-end",
    mb: 0.5,
    style: {
      minHeight: minHeight
    }
  }, bars.map(function (_ref2, index) {
    var value = _ref2.value,
        label = _ref2.label,
        axisLabelX = _ref2.axisLabelX,
        highlightLabel = _ref2.highlightLabel,
        onClick = _ref2.onClick,
        onHover = _ref2.onHover;
    var heightPercent = maxValue === 0 ? 100 : 100 / maxValue * value;
    return _react.default.createElement(_Bar.Bar, {
      key: index,
      heightPercent: allZero ? 0 : heightPercent,
      label: (0, _ChartTooltip.coerceTooltip)(label),
      axisLabelX: axisLabelX,
      highlightLabelRef: highlightLabelRef,
      highlightLabel: (0, _ChartTooltip.coerceTooltip)(highlightLabel),
      hasEnteredViewport: hasEnteredViewport,
      onMeasureHeight: highlightLabel ? setMinHeight : null,
      onClick: onClick,
      onHover: onHover
    });
  })), _react.default.createElement(_Flex.Flex, {
    justifyContent: "space-between"
  }, _react.default.createElement(_Typography.Sans, {
    color: "black60",
    size: "2"
  }, minLabel), _react.default.createElement(_Typography.Sans, {
    color: "black60",
    size: "2"
  }, maxLabel)), bars.filter(function (bar) {
    return bar.axisLabelX;
  }).length > 0 && _react.default.createElement(_Flex.Flex, null, bars.map(function (_ref3, i) {
    var axisLabelX = _ref3.axisLabelX;
    return _react.default.createElement(BarAxisLabelContainer, {
      key: i
    }, _react.default.createElement(AxisLabelX, {
      color: "black60",
      size: "2"
    }, axisLabelX));
  }))));
};

exports.BarChart = BarChart;
BarChart.displayName = "BarChart";

var BarAxisLabelContainer = _styledComponents.default.div.withConfig({
  displayName: "BarChart__BarAxisLabelContainer",
  componentId: "sc-1bkepsb-1"
})(["flex:1;min-height:", "px;position:relative;"], (0, _helpers.space)(2));

var AxisLabelX = (0, _styledComponents.default)(_Typography.Sans).withConfig({
  displayName: "BarChart__AxisLabelX",
  componentId: "sc-1bkepsb-2"
})(["position:absolute;text-align:center;white-space:nowrap;left:50%;transform:translateX(-50%);"]);
//# sourceMappingURL=BarChart.js.map